import type { Cart, Product } from "./types";

export function calculateGuestCart(items: { product: Product; quantity: number }[]): Cart {
  const normalized = items.filter((item) => item.quantity > 0).map((item) => ({ quantity: Math.min(item.quantity, item.product.stock), product: item.product, lineTotal: item.product.price * Math.min(item.quantity, item.product.stock) }));
  const subtotal = normalized.reduce((sum, item) => sum + item.lineTotal, 0);
  const productDiscount = normalized.reduce((sum, item) => sum + Math.max(0, (item.product.previousPrice ?? item.product.price) - item.product.price) * item.quantity, 0);
  return { items: normalized, subtotal, productDiscount, promoDiscount: 0, discount: productDiscount, deliveryPrice: 0, total: subtotal };
}
